import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: "여기에 원하는 값(state값 초기화)을 마음대로 넣으시면 됩니다.",
  //주요 component 별로 나눠 state의 초기값을 넣어주세요.
  //cemsSlice 참조 './cemsSlice'
};

export const sepSlice = createSlice({
  name: "cems",
  initialState,
  reducers: {
    //위의 initialState 안에 있는 state값을 변경 시키는 함수, action
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

// 위에서 등록한 action(예시에선 increment, decrement, incrementByAmount)등을 모두 밑에 넣어주시면 등록됩니다.
export const { increment, decrement, incrementByAmount } = sepSlice.actions;

export default sepSlice.reducer;
